export default __webpack_public_path__ + "static/media/not-all.9ad24117.svg";